// Hotfix sécurité : on garde "*" pour rester compatible avec tous les schémas existants
// (certaines instances n'ont pas exactement les mêmes colonnes).
export const DELIVERY_COLUMNS = '*';

// Une commande livrée est "active" (non archivée) si elle n'a été versée
// ni côté Dakar (versement_id) ni côté Expédition (expedition_versement_id).
export const ACTIVE_DELIVERIES_FILTER =
  'status.neq.delivered,and(versement_id.is.null,expedition_versement_id.is.null)';

// Fallback si versement_id n'existe pas encore en base
export const ACTIVE_DELIVERIES_FILTER_FALLBACK = 'status.neq.delivered';

// Helper: identifie une erreur de colonne manquante
const isMissingColumnError = (error) => {
  if (!error) return false;
  const code = String(error.code || '').toUpperCase();
  const haystack = `${error.message || ''} ${error.details || ''} ${error.hint || ''}`.toLowerCase();
  return (
    code === '42703'
    || code === 'PGRST204'
    || haystack.includes('does not exist')
    || haystack.includes('schema cache')
  );
};

// Vérifie si une commande livrée est encore "active" (non versée)
export const isActiveDelivery = (order) =>
  order.status !== 'delivered' ||
  (order.versement_id == null && order.expedition_versement_id == null);

export async function runActiveDeliveriesQuery(queryFactory) {
  const primary = await queryFactory(ACTIVE_DELIVERIES_FILTER);
  if (!primary?.error) return { ...primary, usedFallback: false };

  if (!isMissingColumnError(primary.error)) {
    return { ...primary, usedFallback: false };
  }

  const fallback = await queryFactory(ACTIVE_DELIVERIES_FILTER_FALLBACK);
  if (!fallback?.error) {
    console.warn('[deliveries] fallback filter used (without versement_id / expedition_versement_id).');
  }
  return { ...fallback, usedFallback: true };
}
